(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart-drawer"]) return;
  try {
    
  (function () {
    var drawer    = document.getElementById('cart-drawer');
    var backdrop  = document.getElementById('cart-backdrop');
    var closeBtn  = document.getElementById('cart-close');
    var body      = document.getElementById('cart-body');
    var subtotalEl = document.getElementById('cart-subtotal-amount');
    var shippingMsg  = document.getElementById('cart-shipping-msg');
    var shippingFill = document.getElementById('cart-shipping-fill');
    var protectToggle = document.getElementById('cart-protect-toggle');
    var titleEl   = document.getElementById('cart-title');

    var FREE_THRESHOLD  = 5000;  // $50.00
    var PROTECTION_PRICE = 200;  // $2.00
    var baseSubtotal  = 0;
    var confettiShown = false;
    var prevTotal     = 0;

    function fmt(cents) {
      return '$' + (cents / 100).toFixed(2);
    }

    /* ── Cart title with item count ── */
    function updateCartTitle(count) {
      if (!titleEl) return;
      titleEl.innerHTML = count > 0
        ? 'YOUR CART <span class="cart-title-count">(' + count + ')</span>'
        : 'YOUR CART';
    }

    /* ── Confetti (Sanative botanical palette) ── */
    function triggerConfetti() {
      var inner = drawer ? drawer.querySelector('.cart-drawer__inner') : null;
      if (!inner) return;
      var canvas = document.createElement('canvas');
      canvas.style.cssText = 'position:absolute;top:0;left:0;width:100%;height:100%;pointer-events:none;z-index:10;';
      canvas.width  = inner.offsetWidth  || 420;
      canvas.height = inner.offsetHeight || 600;
      inner.appendChild(canvas);

      var ctx = canvas.getContext('2d');
      var COLORS = ['#9AAD8F', '#FAF8F5', '#2C2C2C', '#D6C9B5', '#F2EDE6', '#6B8A5E', '#C8D8C0'];
      var particles = [];
      for (var i = 0; i < 70; i++) {
        particles.push({
          x: Math.random() * canvas.width,
          y: -10 - Math.random() * 30,
          w: Math.random() * 8 + 4,
          h: Math.random() * 5 + 3,
          color: COLORS[Math.floor(Math.random() * COLORS.length)],
          vy: Math.random() * 4 + 2,
          vx: Math.random() * 3 - 1.5,
          rot: Math.random() * Math.PI * 2,
          rotSpeed: (Math.random() - 0.5) * 0.15
        });
      }

      var start = null;
      var DURATION = 2000;

      function animate(ts) {
        if (!start) start = ts;
        var elapsed   = ts - start;
        var fadeStart = DURATION * 0.5;
        ctx.clearRect(0, 0, canvas.width, canvas.height);
        particles.forEach(function (p) {
          p.y += p.vy; p.x += p.vx; p.rot += p.rotSpeed;
          var alpha = elapsed < fadeStart ? 1 : 1 - (elapsed - fadeStart) / (DURATION - fadeStart);
          ctx.save();
          ctx.globalAlpha = Math.max(0, alpha);
          ctx.fillStyle   = p.color;
          ctx.translate(p.x, p.y);
          ctx.rotate(p.rot);
          ctx.fillRect(-p.w / 2, -p.h / 2, p.w, p.h);
          ctx.restore();
        });
        if (elapsed < DURATION) {
          requestAnimationFrame(animate);
        } else {
          if (canvas.parentNode) canvas.parentNode.removeChild(canvas);
        }
      }
      requestAnimationFrame(animate);
    }

    /* ── Open / close ── */
    function openDrawer() {
      drawer.classList.add('is-open');
      backdrop.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      document.documentElement.style.overflow = 'hidden';
    }

    function closeDrawer() {
      drawer.classList.remove('is-open');
      backdrop.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      document.documentElement.style.overflow = '';
    }

    /* ── Shipping bar ── */
    function updateShippingBar(total) {
      if (!shippingFill || !shippingMsg) return;
      var remaining = FREE_THRESHOLD - total;
      var pct = Math.min((total / FREE_THRESHOLD) * 100, 100);
      shippingFill.style.width = pct + '%';

      if (remaining <= 0) {
        shippingMsg.textContent   = "🎉 You've unlocked FREE SHIPPING!";
        shippingMsg.style.color   = '#6B8A5E';
        shippingMsg.style.fontWeight = '600';
        if (!confettiShown && prevTotal < FREE_THRESHOLD && prevTotal > 0) {
          confettiShown = true;
          triggerConfetti();
        }
      } else {
        shippingMsg.textContent      = 'Add $' + Math.floor(remaining / 100) + ' more to get FREE SHIPPING!';
        shippingMsg.style.color      = '';
        shippingMsg.style.fontWeight = '';
        confettiShown = false;
      }
      prevTotal = total;
    }

    /* ── Cart count badges ── */
    function updateCartCount(count) {
      document.querySelectorAll('[data-cart-count]').forEach(function (el) {
        el.textContent = count;
        el.classList.toggle('is-hidden', count === 0);
      });
    }

    /* ── Subtotal display (includes optional protection) ── */
    function updateDisplaySubtotal() {
      if (!subtotalEl) return;
      var extra = (protectToggle && protectToggle.checked) ? PROTECTION_PRICE : 0;
      subtotalEl.textContent = fmt(baseSubtotal + extra);
    }

    /* ── Change quantity / remove ── */
    function changeItem(key, qty) {
      if (body) body.style.opacity = '0.5';
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: qty })
      })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          if (body) body.style.opacity = '1';
          renderCart(cart);
          updateCartCount(cart.item_count);
          document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));
          window.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));
        });
    }

    function refreshCart() {
      fetch('/cart.js')
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          renderCart(cart);
          updateCartCount(cart.item_count);
        });
    }

    /* ── Render cart items ── */
    function renderCart(cart) {
      baseSubtotal = cart.total_price;
      updateDisplaySubtotal();
      updateShippingBar(cart.total_price);
      updateCartTitle(cart.item_count);

      var hasItems = cart.item_count > 0;
      var extrasShipping   = document.getElementById('cart-extras-shipping');
      var extrasProtection = document.getElementById('cart-extras-protection');
      if (extrasShipping)   extrasShipping.classList.toggle('cart-extras--visible', hasItems);
      if (extrasProtection) extrasProtection.classList.toggle('cart-extras--visible', hasItems);

      if (!body) return;

      if (cart.item_count === 0) {
        body.innerHTML =
          '<div class="cart-empty">' +
            '<p class="cart-empty__msg">Your cart is empty</p>' +
            '<a href="/collections/all" class="cart-empty__cta">Shop now</a>' +
          '</div>';
        return;
      }

      body.innerHTML = cart.items.map(function (item) {
        var imgSrc      = item.image ? item.image.replace(/(\.[^.]+)$/, '_60x60$1') : '';
        var showVariant = item.variant_title && item.variant_title !== 'Default Title';
        var hasCompare  = item.original_price > item.final_price;
        return (
          '<div class="cart-item" data-key="' + item.key + '">' +
            '<a href="' + item.url + '" class="cart-item__img-wrap">' +
              (imgSrc ? '<img src="' + imgSrc + '" alt="' + item.product_title + '" width="60" height="60" loading="lazy">' : '') +
            '</a>' +
            '<div class="cart-item__details">' +
              '<a href="' + item.url + '" class="cart-item__title">' + item.product_title + '</a>' +
              (showVariant ? '<p class="cart-item__variant">' + item.variant_title + '</p>' : '') +
              '<div class="cart-item__price-row">' +
                (hasCompare ? '<s class="cart-item__compare">' + fmt(item.original_price) + '</s>' : '') +
                '<span class="cart-item__price">' + fmt(item.final_price) + '</span>' +
              '</div>' +
              '<div class="cart-item__qty">' +
                '<button class="cart-qty-btn" data-action="minus" data-key="' + item.key + '" data-qty="' + item.quantity + '" aria-label="Decrease quantity">&#8722;</button>' +
                '<span class="cart-qty-val">' + item.quantity + '</span>' +
                '<button class="cart-qty-btn" data-action="plus"  data-key="' + item.key + '" data-qty="' + item.quantity + '" aria-label="Increase quantity">+</button>' +
                '<button class="cart-remove-btn" data-key="' + item.key + '" aria-label="Remove ' + item.product_title + '">' +
                  '<svg width="12" height="12" viewBox="0 0 12 12" fill="none"><path d="M1 1l10 10M11 1L1 11" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/></svg>' +
                '</button>' +
              '</div>' +
            '</div>' +
          '</div>'
        );
      }).join('');

      body.querySelectorAll('.cart-qty-btn').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var qty  = parseInt(btn.dataset.qty);
          var next = btn.dataset.action === 'plus' ? qty + 1 : Math.max(0, qty - 1);
          changeItem(btn.dataset.key, next);
        });
      });

      body.querySelectorAll('.cart-remove-btn').forEach(function (btn) {
        btn.addEventListener('click', function () { changeItem(btn.dataset.key, 0); });
      });
    }

    /* ── Shipping protection toggle ── */
    if (protectToggle) {
      protectToggle.addEventListener('change', updateDisplaySubtotal);
    }

    /* ── Events ── */
    document.addEventListener('open-cart', function () {
      openDrawer();
      refreshCart();
    });

    document.addEventListener('cart-updated', function (e) {
      if (e.detail) {
        renderCart(e.detail);
        updateCartCount(e.detail.item_count);
      }
    });

    if (closeBtn)  closeBtn.addEventListener('click', closeDrawer);
    if (backdrop)  backdrop.addEventListener('click', closeDrawer);

    /* ── Intercept add-to-cart form submissions ── */
    document.addEventListener('submit', function (e) {
      if (e.target.matches('form[action="/cart/add"]')) {
        e.preventDefault();
        fetch('/cart/add.js', { method: 'POST', body: new FormData(e.target) })
          .then(function () { return fetch('/cart.js'); })
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            document.dispatchEvent(new CustomEvent('cart-updated', { detail: cart }));
            document.dispatchEvent(new CustomEvent('open-cart'));
            window.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));
          });
      }
    });

    refreshCart();
  })();

  } catch(e) { console.error(e); }
})();
})();
